

















































import Vue from 'vue'
import { Table31ElInterface, TableRow } from '@/config/interfaces'

export default Vue.extend({
  name: 'Table13El',

  data: () => ({
    colors: [] as Array<string>
  }),

  computed: {
    resolveStyles (): string {
      return `display: grid;grid-template-columns: 4fr repeat(${this.rowLength}, 3fr);`
    },
    rowLength (): number {
      return Object.keys(this.$props.templateItemData.rows[0]).filter(obj => obj.match('col')).length
    }
  },

  methods: {
    visible (row: TableRow): Array<string> {
      const filtered = Object.entries(row).filter(([key]) => (key.match('col')))
      return Object.values(Object.fromEntries(filtered))
    }
  },

  props: {
    templateItemData: {
      type: Object as () => Table31ElInterface,
      required: true
    }
  }
})
